import { PaymentMethod } from '@stripe/stripe-js';

export interface StripePaymentMethod extends PaymentMethod {
  default: boolean;
}
